 
import api from './api';

const interviewService = {
    getInterviews: async () => {
        const response = await api.get('/interviews');
        return response.data;
    },

    getInterviewById: async (id) => {
        const response = await api.get(`/interviews/${id}`);
        return response.data;
    },

    updateStatus: async (id, status) => {
        const response = await api.put(`/interviews/${id}/status`, { status });
        return response.data;
    },

    deleteInterview: async (id) => {
    const response = await api.delete(`/interviews/${id}`);
    return response.data;
  },
  
};

export default interviewService;
